import { useRuntimeConfig } from '@iheartjane/runtime-config';
import lowerCase from 'lodash-es/lowerCase';
import { Helmet } from 'react-helmet-async';

import { getCanonicalPath } from '@jane/shared-ecomm/components';
import { useMenu } from '@jane/shared-ecomm/providers';
import { useEcommApp } from '@jane/shared/providers';
import {
  appendDispensaryToStoreName,
  statePostalCode,
} from '@jane/shared/util';

/**
 * Used in conjunction with MenuSeo
 * Menu pages share page description and structured data,
 * but have distinct titles and canonical links
 */

export const MenuPageSeo = ({
  path,
  title,
}: {
  path: string;
  title: string;
}) => {
  const { isIframe } = useEcommApp();
  const {
    disableJaneTitleAndDescriptionMeta,
    isFramelessEmbedMode,
    isBoostForAll,
  } = useRuntimeConfig();
  const { store } = useMenu();
  const pageCanonical = getCanonicalPath({
    inIframe: isIframe,
    isBoostWp: isFramelessEmbedMode && !isBoostForAll,
    pagePath: path,
  });
  const pageTitle = `Shop ${lowerCase(title)} cannabis products | ${appendDispensaryToStoreName(store.name, ' Dispensary')} ${store.city}, ${statePostalCode(store.state)}`;

  const disableMeta = Boolean(disableJaneTitleAndDescriptionMeta);

  return (
    <Helmet>
      {!disableMeta && <title>{pageTitle}</title>}
      {!disableMeta && <meta property="og:title" content={pageTitle} />}
      {!disableMeta && <meta property="twitter:title" content={pageTitle} />}

      <link rel="canonical" href={pageCanonical} />
      <meta property="og:url" content={pageCanonical} />
      <meta property="twitter:url" content={pageCanonical} />
    </Helmet>
  );
};
